module.exports = __webpack_public_path__ + "static/media/2DGACM9.99745c18.jpg";